/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface TeamMemberRef
 */
export interface TeamMemberRef {
  /**
   *
   * @type {string}
   * @memberof TeamMemberRef
   */
  teamMemberId: string;
  /**
   *
   * @type {string}
   * @memberof TeamMemberRef
   */
  firstName: string;
  /**
   *
   * @type {string}
   * @memberof TeamMemberRef
   */
  lastName: string;
  /**
   *
   * @type {string}
   * @memberof TeamMemberRef
   */
  email: string;
}

/**
 * Check if a given object implements the TeamMemberRef interface.
 */
export function instanceOfTeamMemberRef(value: object): value is TeamMemberRef {
  if (!("teamMemberId" in value) || value["teamMemberId"] === undefined)
    return false;
  if (!("firstName" in value) || value["firstName"] === undefined) return false;
  if (!("lastName" in value) || value["lastName"] === undefined) return false;
  if (!("email" in value) || value["email"] === undefined) return false;
  return true;
}

export function TeamMemberRefFromJSON(json: any): TeamMemberRef {
  return TeamMemberRefFromJSONTyped(json, false);
}

export function TeamMemberRefFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TeamMemberRef {
  if (json == null) {
    return json;
  }
  return {
    teamMemberId: json["teamMemberId"],
    firstName: json["firstName"],
    lastName: json["lastName"],
    email: json["email"],
  };
}

export function TeamMemberRefToJSON(json: any): TeamMemberRef {
  return TeamMemberRefToJSONTyped(json, false);
}

export function TeamMemberRefToJSONTyped(
  value?: TeamMemberRef | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    teamMemberId: value["teamMemberId"],
    firstName: value["firstName"],
    lastName: value["lastName"],
    email: value["email"],
  };
}
